import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './en'
import zh from './zh'

export const LANGS = ['en', 'zh'] as const
export type Lang = (typeof LANGS)[number]

const STORAGE_KEY = 'visword-locale'

function detectLang(): Lang {
  const saved = localStorage.getItem(STORAGE_KEY)
  if (saved === 'en' || saved === 'zh') return saved
  const nav = typeof navigator !== 'undefined' ? navigator.language : 'en'
  return nav.startsWith('zh') ? 'zh' : 'en'
}

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    zh: { translation: zh },
  },
  lng: detectLang(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnObjects: true,
})

export function setLang(lang: Lang) {
  void i18n.changeLanguage(lang)
  localStorage.setItem(STORAGE_KEY, lang)
}

export function toggleLang(): Lang {
  const next: Lang = i18n.language === 'zh' ? 'en' : 'zh'
  setLang(next)
  return next
}

export default i18n
